export default "__VITE_ASSET__a935d948__"